<template>
  <div>
    <!-- Módulo CFP: pendências de classificação e assistente de rubricas padrão -->
    <ResumoCalculoVerbas
      v-if="calculoFolhaContratado"
      @aplicado="versaoListagem++"
    />
    <ListagemBase
      :key="versaoListagem"
      nomePlural="FuncionarioFolhaPagamentoVerbas"
      nomeSingular="FuncionarioFolhaPagamentoVerba"
      :headers="headersVisiveis"
    >
      <template v-slot:[`item.actions-extra`]="{ item }">
        <v-tooltip v-if="pendenteCalculo(item)" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              small
              color="orange darken-2"
              class="mr-1"
              v-on="on"
              >mdi-alert-outline</v-icon
            >
          </template>
          <span
            >Sem natureza ou incidências do eSocial: não pode ser usada no
            fechamento da folha.</span
          >
        </v-tooltip>
      </template>
    </ListagemBase>
  </div>
</template>

<script>
import FuncionarioFolhaPagamentoVerbaDataService from "@/services/pessoal/FuncionarioFolhaPagamentoVerbaDataService";
const DataService = FuncionarioFolhaPagamentoVerbaDataService;

import ListagemBase from "@/components/base/Crud/ListagemBase";
import moduloCalculoFolha from "@/components/pessoal/folha-calculo/moduloCalculoFolha";
import ResumoCalculoVerbas from "./ResumoCalculoVerbas.vue";

export default {
  name: "ListagemFuncionarioFolhaPagamentoVerbas",
  components: { ListagemBase, ResumoCalculoVerbas },
  mixins: [moduloCalculoFolha],
  data() {
    return {
      DataService: DataService,
      versaoListagem: 0,

      headers: [
        { text: this.$t("Verba"), value: "verba", sortable: "false" },
        {
          text: this.$t("Descricao"),
          value: "descricaoVerba",
          sortable: "false",
        },
        { text: this.$t("Tipo"), value: "tipoVerba", sortable: "false" },
        { text: this.$t("baseINSS"), value: "baseINSS", sortable: "false" },
        { text: this.$t("baseIRRF"), value: "baseIRRF", sortable: "false" },
        { text: this.$t("baseFGTS"), value: "baseFGTS", sortable: "false" },
        {
          text: "eSocial ajustada",
          value: "esocialAjustada",
          sortable: "false",
        },
        { text: this.$t("Responsavel"), value: "responsavel.nome" },

        { text: this.$t("Acoes"), value: "actions", sortable: false },
      ],
    };
  },
  computed: {
    // Com o módulo CFP, a natureza do eSocial entra na lista (é ela que define as incidências no cálculo).
    headersVisiveis() {
      if (!this.calculoFolhaContratado) return this.headers;
      const lista = [...this.headers];
      lista.splice(3, 0, {
        text: "Natureza eSocial",
        value: "naturezaEsocial",
        sortable: "false",
      });
      return lista;
    },
  },
  methods: {
    pendenteCalculo(item) {
      if (!this.calculoFolhaContratado || !item) return false;
      if (item.statusComum && item.statusComum !== "ATIVO") return false;
      return (
        !item.naturezaEsocial ||
        !item.tipoRubricaEsocial ||
        !item.codIncCP ||
        !item.codIncIRRF ||
        !item.codIncFGTS
      );
    },
  },
};
</script>

<style></style>
